import {Component, OnDestroy, OnInit} from '@angular/core';
import {MachinesService} from '../../../services/machines.service';
import {SelectItem} from 'primeng/primeng';
import {Machine} from '../../../models/machine.model';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {AuthenticationService} from '../../../services/authentication.service';

@Component({
  providers: [MachinesService],
  selector: 'app-machine-add',
  templateUrl: './machine.add.component.html',
})
export class MachineAddComponent implements OnDestroy, OnInit {
  public machineTypes: SelectItem[];
  public machine: Machine = new Machine('Nieuw', 'Compressor');
  public error: string;

  private _ngUnSubscribe: Subject<void> = new Subject<void>();

  constructor(private _route: ActivatedRoute, private _machineService: MachinesService, public router: Router,
              private _authService: AuthenticationService) {
    this.machineTypes = [];
    this.machineTypes.push({label: 'Compressor', value: 'Compressor'});
    this.machineTypes.push({label: 'Filter', value: 'Filter'});
    this.machineTypes.push({label: 'Droger', value: 'Droger'});
    this.machineTypes.push({label: 'Snelkoppeling', value: 'Snelkoppeling'});
    this.machineTypes.push({label: 'Tank', value: 'Tank'});
  }

  public ngOnInit() {
    this._route.params
      .takeUntil(this._ngUnSubscribe)
      .subscribe(params => {
        const customerId = params['customerid'];
        this.machine.customer = customerId;
      });
  }

  public ngOnDestroy() {
    this._ngUnSubscribe.next();
    this._ngUnSubscribe.complete();
  }

  public saveMachine(): void {
    if (this.machine.name !== '' && this.machine.customer !== '') {
      this.machine.active = true;
      this._machineService.create(this.machine)
        .subscribe(machine => {
          this.router.navigate(['/customers', this.machine.customer]);
        });
    } else {
      this.error = 'Naam is verplicht.';
    }
  }

  public cancel(): void {
    this.router.navigate(['/customers', this.machine.customer]);
  }

  public isAdmin(): boolean {
    if (this._authService.user && this._authService.user.role === 'admin') {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/machine/add/machine.add.component.ts